import { render, staticRenderFns } from "./DefShare.vue?vue&type=template&id=291ef6a8&"
import script from "./DefShare.vue?vue&type=script&lang=ts&"
export * from "./DefShare.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports